import * as React from 'react';

import { EServiceType } from '../../redux/reducers';

export enum EBuyPackageStatus {
  Confirm = 'Confirm',
  Ok = 'Ok',
  OkWithDeposit = 'OkWithDeposit',
  NotEnoughMoney = 'NotEnoughMoney',
  NotEnoughMoneyWithDeposit = 'NotEnoughMoneyWithDeposit',
  TariffNotAvailable = 'TariffNotAvailable',
  Error = 'Error',
}
export interface IBuyPackageService {
  serviceType: EServiceType;
  icon: React.ReactNode;
  label: string;
  count: number;
  durationInDays?: number;
  auctionPoints: number;
  price: number;
}

export interface IBuyPackageHeldPayment {
  heldAmount?: number;
  transactionId: string;
  requestedAmount: number;
}
export interface IBuyPackageData {
  packageId: number | string;
  autoProlong: boolean;
  packageStartDate: string;
  packageEndDate: string;
  regions: string[];
  category: string;
  price: number;
  marketingPrice: number;
  discountPercent: number;
  announcementPrice: number;
  durationInDays: number;
  announcementsCount: number;
  services: IBuyPackageService[];
  confirmationToken: string;
  heldPayment: IBuyPackageHeldPayment | null;
}

export interface IBuyPackage {
  data: IBuyPackageData;
  status: EBuyPackageStatus;
  message: string;
  isLoading: boolean;
  isModalShow: boolean;
}
